import React from 'react';
import { Sparkles } from 'lucide-react';
import PostCard from './PostCard';
import { ENTITY } from '../utils/constants';

const PostGrid = ({ posts, onSelectPost }) => {
  if (posts.length === 0) {
    return (
      <div className="empty-state">
        <Sparkles size={64} suppressHydrationWarning />
        <h3>{ENTITY.labels.emptyState}</h3>
        <p>{ENTITY.labels.emptyStateDescription}</p>
      </div>
    );
  }

  return (
    <div className="post-grid">
      {posts.map((post, index) => (
        <PostCard
          key={post.id}
          post={post}
          onClick={onSelectPost}
          isHighPriority={index < 3}
        />
      ))}
    </div>
  );
};

export default React.memo(PostGrid);
